import { readString } from 'react-papaparse';

export const convertCsvToJson = (str) => {
    const results = readString(str, { header: true });
    return results.data;
};

export const counterApi = (type) => {
    let gid = 847649831;
    if(type === '3v3') {
        gid = 694836848;
    } else if(type === 'fleet') {
        gid = 1397959394;
    }
    return `https://docs.google.com/spreadsheets/d/e/2PACX-1vR02nOcoyFdc7zEdRJ4U_YFQtkftUukneiJ1xFPxzdOdQgewvaBvMgwTK8ytotxPxWQEMwGIkHCj_kI/pub?gid=${gid}&single=true&output=csv`;
}